import React, { useState, useEffect } from 'react';
import Select, { components } from 'react-select';
import MasterService from './../../services/MasterService';
import { toast } from 'react-toastify';
import Loader from '../common/loader';

const { ValueContainer, Placeholder } = components;
const CustomValueContainer = ({ children, ...props }) => {
    return (
        <ValueContainer {...props}>
            <Placeholder {...props} isFocused={props.isFocused}>
                {props.selectProps.placeholder}
            </Placeholder>
            {React.Children.map(children, child =>
                child && child.type !== Placeholder ? child : null
            )}
        </ValueContainer>
    );
};

const RejectRemapRequestPopup = (props) => {
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [userList, setUserList] = useState([]);
    const [ConfigList, setConfigList] = useState([]);
    const [reason_for_rejection_id, setReasonForRejectionId] = useState(null);
    const [rejection_comment, setRejectionComment] = useState('');

    useEffect(() => {
        getConfigList();
    }, []);

    useEffect(() => {
        if (props.singleUserId) {
            setUserList([{ id: props.singleUserId, is_selected: true }]);
            return;
        }
        if (props?.userList?.user_list?.length) {
            let tempList = props.userList.user_list.filter(ele => ele.is_selected);
            setUserList(tempList);
        }
    }, [props.userList, props.singleUserId]);

    const getConfigList = async () => {
        setLoading(true);
        await MasterService.post('/sfa/user/get-config', { role_id: "", send_bm_grading: false })
            .then(function (response) {
                if (response.data.status === 200) {
                    setConfigList(response.data.data);
                }
            })
            .catch(function () {});
        setLoading(false);
    };

    const handleReasonChange = (e) => {
        setReasonForRejectionId(e.id);
        let tempErrors = { ...errors };
        delete tempErrors['reason_for_rejection_id'];
        setErrors(tempErrors);
    };

    const handleCommentChange = (event) => {
        setRejectionComment(event.target.value);
        let tempErrors = { ...errors };
        delete tempErrors['rejection_comment'];
        setErrors(tempErrors);
    };

    const isFormValid = reason_for_rejection_id && rejection_comment.trim().length > 0;

    const validateForm = () => {
        let result = true;
        let tempErrors = {};
        if (!reason_for_rejection_id) {
            tempErrors.reason_for_rejection_id = 'Reason For Rejection is Required';
            result = false;
        }
        if (rejection_comment.trim() === '') {
            tempErrors.rejection_comment = 'Comment is Required';
            result = false;
        }
        setErrors(tempErrors);
        if (result && !userList.length) {
            toast.error("No User Selected");
            result = false;
        }
        return result;
    };

    const handleRejectSubmit = (e) => {
        e.preventDefault();
        if (!validateForm()) return;
        setLoading(true);
        const params = {
            user_ids: userList.map(e => e.id),
            reason_for_rejection_id,
            rejection_comment: rejection_comment.trim()
        };
        MasterService.post('/sfa/user/rejectRemapRequest', params)
            .then(function (response) {
                setLoading(false);
                if (response.data.status === 200) {
                    toast.success(response.data.message);
                    if (props.onSuccess) props.onSuccess();
                } else {
                    toast.error(response.data.message);
                }
            })
            .catch(function () {
                setLoading(false);
                toast.error("Something went wrong");
            });
    };

    return (
        <>
            {loading ? <Loader /> : null}
            <div className="modal-body">
                <div className='rejection_form'>
                    <form method="post" onSubmit={handleRejectSubmit} style={{ marginTop: "10px" }}>
                        <div style={{ height: "100%" }}>
                            <fieldset className="single-select">
                                {ConfigList?.remap_request_rejection_reason?.length ?
                                    <div className="material">
                                        <Select
                                            components={{ ValueContainer: CustomValueContainer }}
                                            id="reason_for_rejection_id"
                                            name="reason_for_rejection_id"
                                            onChange={handleReasonChange}
                                            options={ConfigList.remap_request_rejection_reason}
                                            value={ConfigList.remap_request_rejection_reason.find((e) => e.id === reason_for_rejection_id) || null}
                                            placeholder="Reason For Rejection*"
                                            className="react-select"
                                            classNamePrefix="react-select"
                                        />
                                        {errors.reason_for_rejection_id ? <span className="error show">{errors.reason_for_rejection_id}</span> : ''}
                                    </div>
                                : null}
                            </fieldset>
                            <fieldset className="p-lg-t p-lg-b">
                                <div className="material">
                                    <textarea
                                        placeholder=''
                                        onChange={handleCommentChange}
                                        rows='6'
                                        className="form-input"
                                        name="rejection_comment"
                                        value={rejection_comment}
                                        maxLength={100}
                                    ></textarea>
                                    {errors.rejection_comment ? <span className="error show">{errors.rejection_comment}</span> : ''}
                                    <label data-label="Write the reasons here*" className="form-label"></label>
                                </div>
                            </fieldset>
                        </div>
                        <div className='row' style={{ marginBottom: "10px", marginTop: "50px" }}>
                            <div className="col-md-12 text-center" style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                                <button type="button" className="btn-line" onClick={props.onClose}>No</button>
                                <button type="submit" className="btn-primary text-center" disabled={!isFormValid}>Yes</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default RejectRemapRequestPopup;
